import store from '~store'

import { abilities } from '~auth'

export default router => {
  router.beforeEach((to, from, next) => {
    // Clear validation message
    if (to.meta.managerRole && abilities.cannot('manage', 'settings')) {
      return next({ name: 'home' })
    }

    return next()
  })
}
